__turbopack_context__.v({
  "textContainer": "LiveCountdown-module__Qz5ZYG__textContainer",
});
